export const MODAL_HEIGHT = {
  MEDIUM: 'medium',
  FULL: 'full',
};
